export const defaultOrderBy = (arr, funcs, dirs, indexKey) => {
	return arr.sort((rowA, rowB) => {
		for (let i = 0; i < funcs.length; i += 1) {
			const comp = funcs[i];
			const desc = dirs[i] === false || dirs[i] === "desc";
			const sortInt = comp(rowA, rowB);
			if (sortInt) {
				return desc ? -sortInt : sortInt;
			}
		}
		// Use the row index for tie breakers
		return dirs[0]
			? rowA[indexKey] - rowB[indexKey]
			: rowB[indexKey] - rowA[indexKey];
	});
};

export const foldersOnTopOrderedBy = (arr, funcs, dirs, indexKey) => {
	function sortFolders(a, b) {
		// force null and undefined to the bottom
		a = a === null || a === undefined ? "" : a;
		b = b === null || b === undefined ? "" : b; // force any string values to lowercase

		a = typeof a === "string" ? a.toLowerCase() : a;
		b = typeof b === "string" ? b.toLowerCase() : b; // Return either 1 or -1 to indicate a sort priority

		if (a > b) {
			return 1;
		}

		if (a < b) {
			return -1;
		} // returning 0, undefined or any falsey value will use subsequent sorts or
		// the index as a tiebreaker

		return 0;
	}
	return arr.sort((rowA, rowB) => {
		const aFolder = rowA._original.type === "Folder";
		const bFolder = rowB._original.type === "Folder";
		for (let i = 0; i < funcs.length; i += 1) {
			const comp = funcs[i];
			const desc = dirs[i] === false || dirs[i] === "desc";
			const sortInt = comp(rowA, rowB);
			if (aFolder && !bFolder) {
				return -1;
			}
			if (!aFolder && bFolder) {
				return 1;
			}
			if (aFolder && bFolder) {
				const folderSortInt = sortFolders(
					rowA._original.filename,
					rowB._original.filename
				);
				return folderSortInt;
			}
			if (sortInt) {
				return desc ? -sortInt : sortInt;
			}
		}
		// Use the row index for tie breakers
		return dirs[0]
			? rowA[indexKey] - rowB[indexKey]
			: rowB[indexKey] - rowA[indexKey];
	});
};
